import React, { FC, SVGProps, useContext } from "react";
import { ThemeContext } from "styled-components";

export const ShoppingBagIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  const theme = useContext(ThemeContext);

  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 5.25V7.5H18V5.25C18 3.60938 16.6406 2.25 15 2.25C13.3594 2.25 12 3.60938 12 5.25ZM9.75 9.75H6.75V19.5C6.75 20.7656 7.78125 21.75 9 21.75H21C22.2656 21.75 23.25 20.7656 23.25 19.5V9.75H20.25V12.375C20.25 12.9844 19.7344 13.5 19.125 13.5C18.5156 13.5 18 12.9844 18 12.375V9.75H12V12.375C12 12.9844 11.4844 13.5 10.875 13.5C10.2656 13.5 9.75 12.9844 9.75 12.375V9.75ZM9.75 7.5V5.25C9.75 2.34375 12.0938 0 15 0C17.9062 0 20.25 2.34375 20.25 5.25V7.5H23.25C24.5156 7.5 25.5 8.53125 25.5 9.75V19.5C25.5 21.9844 23.4844 24 21 24H9C6.51562 24 4.5 21.9844 4.5 19.5V9.75C4.5 8.53125 5.53125 7.5 6.75 7.5H9.75Z"
        fill={theme.color.primary}
      />
    </svg>
  );
};
